import { useMemo } from 'react'
import countryList from 'react-select-country-list'

export default function useCountryList(){
    const countries = useMemo(() => countryList().getData(), []);
    return countries;
}